import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import ActivityDeals from "./ActivityDeals";

export default function Activities({setData, form, activities}) {
    let deals = [];

    activities.forEach((item) => {
        deals[item.id] = item.deals
    })

    const carouselSettings = {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
        ]
    };

    const loadActivityDeals = (item, deals) => {
        let dealData = {}

        deals[item?.id].forEach((deal) => {
            if (deal.selected && form?.deal !== deal.id) {
                dealData = {
                    deal: deal.id,
                    dealPrice: deal.price,
                }
            }
        })
        setData({activity: item.id, ...dealData})
    }


    return (
        <>
            <div className="activity_bg">
                <div className={'activities_container'}>
                    <Slider {...carouselSettings}>
                        {
                            activities.map((item) => {
                                let className = form?.activity === item.id ? 'activity_item_selected' : 'activity_item';
                                return (
                                    <div key={'activity_' + item.id} onClick={() => loadActivityDeals(item, deals)}>
                                        <div className={className}
                                             style={{"backgroundImage": `url(` + item.image + `)`}}>
                                        </div>
                                        <div className={'title'}>
                                            {item.name}
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </Slider>
                </div>
            </div>
            <div className={'activity_deals'} key={'activity_' + (form?.activity ?? 0)}>
                <h2>4: Select the length of your event</h2>
                <div className={'activity_items_bg'}>
                    <div className={'activity_items_container'}>
                        <ActivityDeals form={form} setData={setData} deals={deals}/>
                        <div style={{clear: 'both'}}></div>
                    </div>
                </div>
            </div>
        </>
    );
}

